import React from "react";
import { FlexContainer, LottieLoadingIndicator } from "src/components";
import { TextLabel } from "./style";
import Delete from "src/img/Delete.svg";
import { LoadingIndicatorButton } from "src/scenes/Survey/components/Utils";

export default function ConfirmDialog(props) {
    const { title, subtitle = null, toggleModal, deleteFunction, isLoading } = props;
    return (
        <div style={{
            padding: "40px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px"
        }}
        >
            <img src={Delete} height="50px" width="50px" style={{ color: "red", placeSelf: "centers" }} />
            <TextLabel>{`Are you sure you want to delete this ${title}?`}</TextLabel>
            {subtitle && (<TextLabel style={{ whiteSpace: "pre-line", textAlign: "center", fontSize: 14 }}>{subtitle}</TextLabel>)}
            <FlexContainer direction="row" gap="20px">
                <button
                    type="button"
                    onClick={() => toggleModal()}
                    style={{
                        width: "140px",
                        height: "38px",
                        backgroundColor: "#FFFFFF",
                        color: "#000000",
                        border: "1px solid #000000",
                        borderRadius: "10px",
                        font: "normal normal 500 14px/16px Manrope",
                        background: " #FFFFFF 0% 0% no-repeat padding-box"
                    }}
                >
                    Cancel
                </button>
                {isLoading ?
                    <LoadingIndicatorButton>
                        <LottieLoadingIndicator height="2rem" width="2rem" margin="5px" containerHeight="2rem" />
                    </LoadingIndicatorButton>
                    :
                    <button
                        type="button"
                        onClick={() => deleteFunction()}
                        style={{
                            width: "140px",
                            height: "38px",
                            borderRadius: "7px",
                            background: "#FF3B3B 0% 0% no-repeat padding-box",
                            opacity: 1,
                            border: "#FF3B3B",
                            color: "#FFFFFF"
                        }}
                    >
                        Delete
                    </button>}
            </FlexContainer>
        </div>
    );
}
